import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as CryptoJS from 'crypto-js'
import { CommonService } from '../../../../shared/common.service';
import { TaxationService } from './service/taxation.service';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import { IncomeStatementService } from '../../income-statement/income-statement.service';

@Component({
  selector: 'app-taxation',
  templateUrl: './taxation.component.html',
  styleUrls: ['./taxation.component.scss']
})
export class TaxationComponent implements OnInit {


  CreateTaxationFormGroup: FormGroup;
  Grid_Total: number;
  isJump: any;
  NormalRoutng: boolean;
  disableTaxation: boolean;
  showBubbledata: any;
  valid: boolean = true;
  constructor(public FormBuilder: FormBuilder, private incomeStatementService: IncomeStatementService,  public TaxationService: TaxationService, public Router: Router, public commonService: CommonService, private sidenav: SideNavService) {

  }

  ngOnInit(): void {
    debugger
    this.getIncomeStatementData()
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.CreateTaxationFprm();
    this.ListCreateTaxationFormGroupGrid.clear();
    this.GetTaxation();
    this.commonService.getNotesData();
    this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.CreateTaxationFormGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetTaxation_LY()
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true") {
      this.CreateTaxationFormGroup.disable()
      this.disableTaxation = true
    }
    //this.getIncomeStatementData();
  }

  IncomeTaxation: any
  getIncomeStatementData() {
    debugger
    var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.incomeStatementService.getIncomeStatement(APPeriodId).subscribe((data1) => {
      this.IncomeTaxation = data1;
    })
  }

  CreateTaxationFprm() {
    this.CreateTaxationFormGroup = this.FormBuilder.group({
      TaxationId: new FormControl(),
      MasterIdx: new FormControl(),
      TotalCurrentTaxExpenseCredit: new FormControl(),
      TotalDeferredTaxExpenseCredit: new FormControl(),

      TotalCurrentTaxExpenseCredit_LY: new FormControl(),
      TotalDeferredTaxExpenseCredit_LY: new FormControl(),

      TaxOnProfitOrLossOnOrdinaryActivities: new FormControl({ value: null, disabled: true }),
      TaxTaxCreditOnProfitOrLossOnOrdinaryActivities_LY: new FormControl({ value: null, disabled: true }),

      CorporationTaxPayable: new FormControl({ value: '', disabled: true }), //Total
      DeferredTaxPolicy: new FormControl(),

      ForeignTaxPayable: new FormControl(),
      ForeignTaxPayable_LY: new FormControl(),
      AndicaTaxOnProfitOrLossOnOrdinaryActivities: new FormControl(),
      AndicaTaxOnProfitOrLossOnOrdinaryActivities_LY: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      ModifiedBy: new FormControl(),
      MatchingData: new FormControl(),

      WizardList: this.FormBuilder.array([
        this.FormBuilder.group({
          TaxationId: new FormControl(),
          MasterId: new FormControl(),
          Description: new FormControl(),
          Total: new FormControl(),
          Total_LY: new FormControl(),
          CreatedBy: new FormControl(),
          CreatedDate: new FormControl(),
          ModifiedBy: new FormControl(),
          ModifiedDate: new FormControl(),
        })])
    })
  }
  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        var MatchingData = this.CreateTaxationFormGroup.controls['MatchingData'].value;
        this.CreateTaxationFormGroup.reset();
        this.ListCreateTaxationFormGroupGrid.clear();
        this.CreateTaxationFormGroup.controls['MatchingData'].setValue({ Item1: MatchingData.Item1, Item2: MatchingData.Item2 });
        this.CreateTaxationFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }


  GetTaxation() {
    debugger;
    this.TaxationService.GetOneTaxation(this.CreateTaxationFormGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      if (data.WizardList)
        for (let i = 0; i < data.WizardList.length; i++) {
          this.ListCreateTaxationFormGroupGrid.push(this.FormBuilder.group({
            TaxationId: data.WizardList[i].TaxationId, MasterId: data.WizardList[i].MasterId,
            Description: data.WizardList[i].Description, Total: data.WizardList[i].Total ? data.WizardList[i].Total:0, Total_LY: data.WizardList[i].Total_LY?data.WizardList[i].Total_LY:0
          }));
        }
      this.CreateTaxationFormGroup.patchValue(data);
      this.CreateTaxationFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }

  GetTaxation_LY() {
    debugger;
    this.TaxationService.GetOneTaxation_LY(this.CreateTaxationFormGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger;
      this.showBubbledata = data;
      this.CreateTaxationFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }

  On_Next() {
    debugger;
    if (this.Gridvalidations()) {
      if (this.On_NextIncomestatementValidaton() && this.On_NextPageValidation()) {
        this.TaxationService.SaveTaxation(this.CreateTaxationFormGroup.getRawValue()).subscribe(data => {
          this.CreateTaxationFormGroup.markAsPristine();
          if (this.NormalRoutng)
            return true;
          var nextPage;
          nextPage = this.commonService.getNextNoteSelection("Taxation", this.commonService.NotesList)
          if (this.isJump == 'true')
            this.Router.navigate(['/notes'])
          else if (nextPage == 'taxation') {
            nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
            this.Router.navigate([nextPage]);
          }
          else {
            this.Router.navigate([nextPage]);
          }
        })
      }
      else {
        this.NormalRoutng = false;
        return false;
      }
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }    
  On_Back() {
    debugger;
    this.CreateTaxationFormGroup.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Taxation", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }

  AddNew() {
    debugger;
    if (this.Gridvalidations()) {
      this.ListCreateTaxationFormGroupGrid.push(this.FormBuilder.group({ TaxationId: '', MasterId: '', Description: '', Total: '', Total_LY: '', IsDeleted: '' }));
    }
    //  this.ListCreateTaxationFormGroupGrid.clear();

  }

  DeleteRow(index) {
    debugger;
    Swal.fire({
      titleText: "Andica Accounts Production",
      text: 'Are you sure you want to delete?',
      icon: "question",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((data) => {
      if (data.value) {
        this.ListCreateTaxationFormGroupGrid.removeAt(index);
        this.CalculationsGrid();
      }
    })
  }



  Calculations() {
    debugger;
    var total1 = +this.CreateTaxationFormGroup.controls['TotalCurrentTaxExpenseCredit'].value + +this.CreateTaxationFormGroup.controls['TotalDeferredTaxExpenseCredit'].value;
    var total2 = +this.CreateTaxationFormGroup.controls['TotalCurrentTaxExpenseCredit_LY'].value + +this.CreateTaxationFormGroup.controls['TotalDeferredTaxExpenseCredit_LY'].value;
    this.CreateTaxationFormGroup.controls['TaxOnProfitOrLossOnOrdinaryActivities'].setValue(total1 == 0 ? '' : total1);
    this.CreateTaxationFormGroup.controls['TaxTaxCreditOnProfitOrLossOnOrdinaryActivities_LY'].setValue(total2 == 0 ? '' : total2);


  }

  CalculationsGrid() {
    debugger;
    this.Grid_Total = 0;
    for (var i = 0; i < this.ListCreateTaxationFormGroupGrid.length; i++) {
      this.Grid_Total = this.Grid_Total + +this.ListCreateTaxationFormGroupGrid.value[i].Total
    }
    this.Grid_Total = this.Grid_Total == 0 ? null : this.Grid_Total
    this.CreateTaxationFormGroup.controls['CorporationTaxPayable'].setValue(this.Grid_Total)

  }

  Gridvalidations() {
    debugger;
    if (this.ListCreateTaxationFormGroupGrid.length) {
      var data = [];
      for (var j = 0; j < this.ListCreateTaxationFormGroupGrid.length; j++) {
        var v = this.CreateTaxationFormGroup.value.WizardList.filter(x => x.Description == this.ListCreateTaxationFormGroupGrid.value[j].Description)
        if (v.length > 1) {
          data = v;
          Swal.fire("Andica Accounts Production", "Item Description is already present.", 'warning');
          return false;
        }
      }
    }
    if (this.CreateTaxationFormGroup.value.WizardList.length > 0) {
      for (var i = 0; i < this.CreateTaxationFormGroup.value.WizardList.length; i++) {
        if ((this.CreateTaxationFormGroup.value.WizardList[i].Description == null || this.CreateTaxationFormGroup.value.WizardList[i].Description == "")) {
          /*Swal.fire("Andica Accounts Production", 'Item description must be completed.', 'warning');*/
          this.valid = false;
          return false;
        }
        else {
          this.valid = true;
        }
      }
    } else {
      this.valid = true;
    }
    return true;

    //if (this.ListCreateTaxationFormGroupGrid.length == 0)
    //  return true;

    //if (!this.ListCreateTaxationFormGroupGrid.value[this.ListCreateTaxationFormGroupGrid.length-1].Description) {
    //    Swal.fire("Andica Accounts Production", "'Item description' must be completed.", 'info');
    //    return false;
    //}

    //return true;
  }


  On_NextPageValidation() {
    debugger;
    if (+this.CreateTaxationFormGroup.controls['TaxOnProfitOrLossOnOrdinaryActivities'].value != +this.CreateTaxationFormGroup.controls['CorporationTaxPayable'].value) {
      Swal.fire("Andica Accounts Production", "The value in field Total must be equal to Tax on profit on ordinary activities.", 'warning');

      //Swal.fire({
      //  titleText: "Andica Accounts Production",
      //  text: "The value in field 'Total' must be equal to 'Tax on profit on ordinary activities'.",
      //  showConfirmButton: true,
      //  icon: 'warning',

      //})
      return false;
    }
    else
      return true
    // return true
  }

  On_NextIncomestatementValidaton() {
    debugger;
    if (this.commonService.showControl == true) {
      if (this.commonService.AccountTemplateId == 11) {
        //if (+this.CreateTaxationFormGroup.controls['TaxOnProfitOrLossOnOrdinaryActivities'].value != +this.IncomeTaxation.FRS101_Taxation) {
        //  Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
        //  return false;
        //}
        //else if (+this.CreateTaxationFormGroup.controls['TaxTaxCreditOnProfitOrLossOnOrdinaryActivities_LY'].value != +this.IncomeTaxation.FRS101_Taxation_LY) {
        //  Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.LastYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.LastYear + ".", 'warning');
        //  return false;
        //}
        //else
          return true
      } else {
        if (+this.CreateTaxationFormGroup.controls['TaxOnProfitOrLossOnOrdinaryActivities'].value != +this.CreateTaxationFormGroup.controls['MatchingData'].value.Item1) {
          Swal.fire("Andica Accounts Production", "Tax on profit on ordinary activities value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
          return false;
        }
        else if (+this.CreateTaxationFormGroup.controls['TaxTaxCreditOnProfitOrLossOnOrdinaryActivities_LY'].value != +this.CreateTaxationFormGroup.controls['MatchingData'].value.Item2) {
          Swal.fire("Andica Accounts Production", "Tax on profit on ordinary activities value for the year " + this.commonService.LastYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.LastYear + ".", 'warning');
          return false;
        }
        else
          return true
      }
    }
    else {
      if (this.commonService.AccountTemplateId == 11) {
        //if (+this.CreateTaxationFormGroup.controls['TaxOnProfitOrLossOnOrdinaryActivities'].value != +this.IncomeTaxation.FRS101_Taxation) {
        //  Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
        //  return false;
        //}
        //else
          return true
      } else {
        if (+this.CreateTaxationFormGroup.controls['TaxOnProfitOrLossOnOrdinaryActivities'].value != +this.CreateTaxationFormGroup.controls['MatchingData'].value.Item1) {
          Swal.fire("Andica Accounts Production", "Tax on profit on ordinary activities value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
          return false;
        }
        else
          return true
      }
    }
  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.CreateTaxationFormGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.On_Next())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }

  get ListCreateTaxationFormGroupGrid() {
    return this.CreateTaxationFormGroup.get('WizardList') as FormArray;
  }

  duplicatevalidation() {

  }
}
